import { Turbo } from "@hotwired/turbo-rails";
import "@lib/preline_loader";
import { runComponentPackages, runControllerPackage } from "@lib/packageRunner";
import { application } from "@controllers/application";
import ProfileController from "@controllers/common/profile/profile";
import MapsController from "@controllers/common/google/google_maps";
import FieldError from "@controllers/common/field-error/field-error";
import TeamController from "@controllers/team/team";
import CarouselController from "@controllers/preline/carousel/carousel";
import MultiCarouselController from "@controllers/preline/carousel/multi-carousel";
import DatepickerController from "@controllers/common/datepicker/datepicker";
import B2bOnboardingFormController from "@controllers/preline/b2b_onboarding/b2b_onboarding_form";
import ProgressController from "@controllers/preline/progress/progress";
import LoadingController from "@controllers/preline/loading/loading";
import CardController from "@controllers/preline/card/card";
import ButtonController from "@controllers/preline/button/button";
import ReviewsIoWidgetController from "@controllers/preline/reviews_io_widget/reviews_io_widget";
import ToggleVisibilityController from "@controllers/preline/toggle-visibility/toggle-visibility";
import DisableController from "@controllers/preline/disable/disable";
import TopStepperController from "@controllers/preline/top_stepper/top_stepper";
import MailingAddressToggleController from "@controllers/preline/mailing_address_toggle/mailing_address_toggle";
import DateMaskController from "@controllers/preline/date_mask/date_mask";
import FieldValidationController from "@controllers/preline/validation/field_validation";
import ModalController from "@controllers/preline/modal/modal";
import PostcodeMismatchController from "@controllers/preline/postcode_mismatch/postcode_mismatch";
import ToggleRelationshipController from "@controllers/preline/toggle_relationship/toggle_relationship";
import ToggleFormSubmitController from "@controllers/preline/toggle_form_submit/toggle_form_submit";
import DiscountFormController from "@controllers/preline/discount_form/discount_form";
import PlanSelectorController from "@controllers/preline/plan_selector/plan_selector";
import AutoHideController from "@controllers/preline/auto_hide/auto_hide";
import PaymentFormController from "@controllers/preline/prepaid_payments/payment_form";
import ServicePreferenceController from "@controllers/at_need/service_preference_controller";
import WillFormValidationController from "@controllers/wills/will_form_validation";

application.register("will-form-validation", WillFormValidationController);
application.register("team", TeamController);
application.register("google_maps", MapsController);
application.register("profile", ProfileController);
application.register("field-error", FieldError);
application.register("carousel", CarouselController);
application.register("multi-carousel", MultiCarouselController);
application.register("datepicker", DatepickerController);
application.register("b2b-onboarding-form", B2bOnboardingFormController);
application.register("loading", LoadingController);
application.register("progress", ProgressController);
application.register("card", CardController);
application.register("button", ButtonController);
application.register("reviews-io-widget", ReviewsIoWidgetController);
application.register("toggle-visibility", ToggleVisibilityController);
application.register("disable", DisableController);
application.register("top_stepper", TopStepperController);
application.register("mailing-address-toggle", MailingAddressToggleController);
application.register("date-mask", DateMaskController);
application.register("field-validation", FieldValidationController);
application.register("modal", ModalController);
application.register("postcode_mismatch", PostcodeMismatchController);
application.register("toggle-relationship", ToggleRelationshipController);
application.register("toggle-form-submit", ToggleFormSubmitController);
application.register("discount-form", DiscountFormController);
application.register("plan-selector", PlanSelectorController);
application.register("auto-hide", AutoHideController);
application.register("payment_form", PaymentFormController);
application.register("service-preference", ServicePreferenceController);

Turbo.session.drive = false;
document.addEventListener("DOMContentLoaded", async () => {
  runControllerPackage();
  runComponentPackages();
});

document.documentElement.addEventListener("turbo:load", () => {
  window.HSStaticMethods.autoInit();
  runControllerPackage();
  runComponentPackages();
});

document.documentElement.addEventListener("turbo:frame-load", () => {
  window.HSStaticMethods.autoInit();
  runControllerPackage();
  runComponentPackages();
});

document.documentElement.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render;

  event.detail.render = function (streamElement) {
    render(streamElement);
    window.HSStaticMethods.autoInit();

    const resizeEvent = new Event("resize");
    window.dispatchEvent(resizeEvent);

    const customEvent = new CustomEvent("turbo:after-stream-render", { detail: streamElement });
    document.dispatchEvent(customEvent);
  };
});
